'use client';

import type { FC, ReactNode } from 'react';

import type { Article, ArticlePreview } from '@hyex/dxp/types/blog/Article';
import useIsMobile from '@hyex/utils/hooks/useIsMobile';

import CategoryArticleGrid from './grid';
import CategoryArticleBase from '@hyex/modules/shared/Article/views/category-article';
import Grid from '@hyex/modules/shared/Grid';

type PropTypes = {
  items: ArticlePreview[];
  categoryPath?: string;
  articlePath?: string;
  prefetchLinks?: boolean;
};

const CategoryArticleList: FC<PropTypes> = ({
  items,
  categoryPath,
  articlePath,
  prefetchLinks = true,
}) => {
  const isMobile = useIsMobile(822);

  const articles = () =>
    items &&
    items.map((article, i) => {
      return (
        <div className="embla-slide" key={article.id}>
          <CategoryArticleBase
            key={i}
            article={article}
            className="category-article"
            withCategory={false}
            categoryPath={categoryPath}
            articlePath={articlePath}
            prefetchLinks={prefetchLinks}
          />
        </div>
      );
    });

  return (
    <>
      <Grid
        carouselElements={articles}
        isMobile={isMobile}
        gridElement={() => (
          <CategoryArticleGrid
            topArticle={items && items[0]}
            items={items}
            showTopArticle={items && items.length > 3}
            categoryPath={categoryPath}
            articlePath={articlePath}
          />
        )}
        carouselSliderClassName="articles-slider"
        carouselParentClassName="category-article-list"
        wrapperClassName="category-article-wrapper"
        maxLength={9999}
      />
    </>
  );
};

export default CategoryArticleList;
